import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setCache } from "../util/Cache"; 
import { PetugasMeterItem } from "../model/Hublang";
import { fetchGetKoreksiMeterPetugas } from "../controller/dashboard/Cekmeter";
import { Filter } from "lucide-react";

export default function LoginPetugas () {
    const navigate = useNavigate();
    const styles: { [key: string]: React.CSSProperties } = {
        button: {
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 24px',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            textDecoration: 'none',
            transition: 'background-color 0.3s ease',
            marginTop: '20px'
        },
    };

    const [namaPegawaiFilter, setNamaPegawaiFilter] = useState<string>('');
    const [wilayahPegawaiFilter, setWilayahPegawaiFilter] = useState<string>('');

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 

    const [statusLength, setStatusLength] = useState('10');
    const [petugasMeterData, setPetugasMeterData] = useState<PetugasMeterItem[]>([]);

    const uniqueNamaPegawai = Array.from(new Set(petugasMeterData.map(item => item.nama))).filter(Boolean).sort((a,b) => a.localeCompare(b));
    const uniqueWilayahPegawai = Array.from(new Set(petugasMeterData.map(item => item.wilayah))).filter(Boolean);

    const filteredPhotoMeters = petugasMeterData.filter(pgw => {
        const matchesSearch = true;
        const matchesStatus = (namaPegawaiFilter === pgw.nama) ||
        (wilayahPegawaiFilter === pgw.wilayah);

        return matchesSearch && matchesStatus;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPhotoMeters = filteredPhotoMeters.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredPhotoMeters.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const initDataPhotoMeter = async () => { 
        setLoading(true); // Set loading state ke true sebelum memulai fetch
        try {
            const res = await fetchGetKoreksiMeterPetugas(); // Panggil API
            if (res.status === 200 && Array.isArray(res.data)) {

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const processedData = res.data.map((item: any) => ({
                    no: 0,
                    nama: item.nama || "Tidak ada data",
                    wilayah: item.wilayah || "Tidak ada data",
                }));

                const sortedData = processedData;
                setPetugasMeterData(sortedData);
            } else {
                console.error("Invalid response data:", res.data);
                setPetugasMeterData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setPetugasMeterData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (dataPegawai : any | null) => {
        console.log(dataPegawai);
        setCache('current_user', { username : dataPegawai.nama });
        navigate("/dashboard");
    }

    const RenderTablePetugasMeter = ({ filteredData }: { 
        filteredData: PetugasMeterItem[] | null; 
    }) => (
      <>
        {
          filteredData && filteredData.length > 0 ? (
            filteredData.map((plg, idx) => (
              <tr key={idx} className="bg-gray-50 hover:bg-gray-200 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                    {idx + 1}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.nama}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                    {plg.wilayah}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <button style={styles.button} onClick={() => handleSubmit(plg)}>Pilih</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={18} className="text-center py-4 text-gray-500">
                Tidak ada data
              </td>
            </tr>
          )
        }
      </>
    );
    
    useEffect(() => {
      initDataPhotoMeter();
      setItemsPerPage(Number(statusLength === 'all' ? petugasMeterData.length : statusLength))
    }, []);

    return (
      <>

        {/* Controls 1*/}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                {/* Search input - spans banyak kolom di layar md+ */}
                {/* <div className="col-span-1 md:col-span-6">
                <div className="relative">
                    <input
                    type="text"
                    placeholder="Cari Nama"
                    value={uniqueNama.includes(statusFilter.nama) ? statusFilter.nama : ''}
                    onChange={(e) => setStatusFilter({ ...statusFilter, nama: e.target.value })}
                    className="w-full pl-4 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                </div>
                </div> */}

                {/* Pelanggan */}
                <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                        <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                        <select
                            value={namaPegawaiFilter}
                            onChange={(e) => setNamaPegawaiFilter(e.target.value)}
                            className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                            <option value="all">Pegawai</option>
                            {uniqueNamaPegawai.map((item, idx) => (
                                <option value={item} key={idx}>{item}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                        <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                        <select
                            value={wilayahPegawaiFilter}
                            onChange={(e) => setWilayahPegawaiFilter(e.target.value)}
                            className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                            <option value="all">Pelanggan</option>
                            {uniqueWilayahPegawai.map((item, idx) => (
                                <option value={item} key={idx}>{item}</option>
                            ))}
                        </select>
                    </div>
                </div> */}
            </div>
        </div>

        {/* Employee Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
              <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NO
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NAMA
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    WILAYAH
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                  {
                    loading? 
                    <>
                      <tr>
                        <td colSpan={18} className="text-center py-4 text-gray-500">
                          Sedang Loading . . .
                        </td>
                      </tr>
                    </>
                    :
                    <>
                      <RenderTablePetugasMeter filteredData={currentPhotoMeters} />
                    </>
                  }
              </tbody>
            </table>
          </div>
        </div>
  
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-700">
          Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
          <span className="font-medium">{statusLength === "all" ? petugasMeterData.length : statusLength}</span> dari{' '}
          <span className="font-medium">{petugasMeterData.length}</span> karyawan
          <span className="font-medium">( Dari Sortir {filteredPhotoMeters.length} )</span>
        </div>
        <div className="flex space-x-2">
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          First
          </button>
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(prev => prev - 1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          Previous
          </button>
          
          {pageNumbers
          .slice(
            Math.max(0, currentPage - 3), 
            Math.min(currentPage + 2, totalPages)
          )
          .map((page) =>( 
            <button 
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
            {page}
            </button>
          ))}
          
          <button 
              disabled={currentPage === Math.ceil(filteredPhotoMeters.length / itemsPerPage)}
              onClick={() => setCurrentPage(prev => prev + 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Next
          </button>
          <button 
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Last
          </button>
        </div>
        </div>
      </>
    )
};
  
